// import { initFounderHighLight } from "./blocks/founder-highlight";
import { initButton } from "./blocks/button";
import { initImage } from "./blocks/image";
import { initRollingContent } from "./blocks/rolling-content";

// uncomment this line if you need some special component logic from classic frontend components
import { initComponents } from "./components/components";

window.addEventListener("DOMContentLoaded", function () {
	// initFounderHighLight();
	initButton();
	initImage();
	initRollingContent();

	// initComponents has some shared logic with the frontend app.js (ie. slideshows)
	initComponents();
});
